import { Icon } from '../../../../layout/Icon.jsx';
import { Pill } from '../../../../layout/Pill.jsx';
import { formatIQD, formatDateTime } from '../../../../shared/format.js';
import { refObject, refName, userName } from '../../helpers/refs.js';

const METHOD_LABEL = {
  cash: 'نقدي',
  transfer: 'تحويل',
  external: 'خارجي'
};

// حالة المصروف في الخادم: recorded | cancelled (لا active).
const STATUS_LABEL = {
  recorded: 'مسجل',
  active: 'مسجل',
  cancelled: 'ملغي',
  pending: 'قيد المراجعة'
};

const STATUS_TONE = {
  recorded: 'success',
  active: 'success',
  cancelled: 'danger',
  pending: 'warning'
};

export function ExpenseRow({ expense, canEdit, canCancel, onEdit, onCancel, onView, onViewAttachment }) {
  const cat = refObject(expense.category || expense.categoryId);
  const status = expense.status || (expense.cancelledAt ? 'cancelled' : 'recorded');
  const isCancelled = status === 'cancelled';

  return (
    <tr className="border-b border-line">
      <td className="p-2.5 text-ink-2 whitespace-nowrap">{formatDateTime(expense.date || expense.createdAt)}</td>
      <td className="p-2.5">
        <div className="flex items-center gap-2">
          <span
            className="w-2.5 h-2.5 rounded-full flex-none"
            style={{ background: cat.color || '#FF7A1A' }}
          />
          <span className="font-semibold text-[12.5px] truncate" style={{ maxWidth: 140 }}>
            {cat.name || '—'}
          </span>
        </div>
      </td>
      <td
        className={`p-2.5 font-bold ${isCancelled ? 'line-through text-ink-3' : ''}`}
        style={{ color: isCancelled ? undefined : '#C2570D' }}
      >
        {formatIQD(expense.amount || 0)}
      </td>
      <td className="p-2.5 text-[12px]">{METHOD_LABEL[expense.paymentMethod] || expense.paymentMethod || '—'}</td>
      <td className="p-2.5 text-[12px] text-ink-2 truncate" style={{ maxWidth: 140 }}>
        {refName(expense.cashbox || expense.cashboxId)}
      </td>
      <td className="p-2.5 text-[12px] text-ink-2 truncate" style={{ maxWidth: 140 }}>
        {userName(expense.createdBy || expense.createdById)}
      </td>
      <td className="p-2.5 text-ink-2 truncate text-[12px]" style={{ maxWidth: 220 }}>
        {expense.description || '—'}
      </td>
      <td className="p-2.5">
        {expense.attachment || expense.attachmentUrl ? (
          <button
            type="button"
            className="btn btn-ghost"
            style={{ padding: 4 }}
            title="عرض المرفق"
            onClick={() => onViewAttachment?.(expense)}
          >
            <Icon name="search" size={14} />
          </button>
        ) : (
          <span className="text-ink-3">—</span>
        )}
      </td>
      <td className="p-2.5">
        <Pill variant={STATUS_TONE[status] || 'muted'}>{STATUS_LABEL[status] || status}</Pill>
      </td>
      <td className="p-2.5">
        <div className="flex items-center gap-1 justify-end">
          <button
            type="button"
            className="btn"
            style={{ padding: '4px 8px' }}
            onClick={() => onView?.(expense)}
            title="تفاصيل المصروف"
          >
            <Icon name="search" size={13} />
          </button>
          {canEdit && !isCancelled ? (
            <button
              type="button"
              className="btn"
              style={{ padding: '4px 8px' }}
              onClick={() => onEdit?.(expense)}
              title="تعديل البيانات"
            >
              <Icon name="edit" size={13} />
            </button>
          ) : null}
          {canCancel && !isCancelled ? (
            <button
              type="button"
              className="btn btn-danger"
              style={{ padding: '4px 8px' }}
              onClick={() => onCancel?.(expense)}
              title="إلغاء"
            >
              <Icon name="x" size={13} />
            </button>
          ) : null}
        </div>
      </td>
    </tr>
  );
}
